<template>
<video style="padding:0;width:100%;height:100%;" :src="url" controls></video>

</template>
<script>
export default{
    name:'videoViewer',
     props:{
        url:{
            type: String,
            required:true
        }
    }
    
}
</script>